import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface LoaderProps {
  message?: string;
  fullScreen?: boolean;
}

/**
 * Loader component that displays a loading spinner
 * Can be configured to show on the full screen or inline
 * Optionally displays a loading message
 */
const Loader: React.FC<LoaderProps> = ({ message = 'Loading...', fullScreen = false }) => {
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        width: '100%',
        height: fullScreen ? '100vh' : '100%',
      }}
    >
      <CircularProgress color="secondary" size={50} thickness={4} />
      {message && (
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            color: 'text.secondary',
            fontWeight: 500,
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );

  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
};

export default Loader; 